/** FOR DEVELOPMENT ENV ONLY. COMMENT OUT BEFORE BUILD /DEPLOY */
// export const url = 'https://production.kaps.co.ke:3056/api/v1';
// export const api_url = 'https://production.kaps.co.ke:3056/api/v1';
// export const s_server = 'https://production.kaps.co.ke:3056';

/** PRODUCTION. UNCOMMENT  BEFORE BUILD /DEPLOY */
export const url = 'https://api.lukhu.co.ke/api/v1';
export const api_url = 'https://api.lukhu.co.ke/api/v1';
export const s_server = 'https://api.lukhu.co.ke';
